import { docType } from "../datatypes"
import { ISettingsUIcomponents } from "../userconfigTypes"

export type gdtSettingValue = {
    dir: string
    enabled: boolean
    requireRead: boolean
    requireWrite: boolean
  }

export type gdtSettingConfig<kind> = {
    /* foo: "test" */
  } & (
    kind extends 'gdtOutputFolder' ? {
        placeholder: string
        UIcomponent: ISettingsUIcomponents
        onSave: (setting: gdtSettingValue) => Promise<any>

    } : kind extends 'gdtInputFolder' ? {
        UIcomponent: ISettingsUIcomponents
        onNewDocument: (doc: any) => Promise<any>
        routine: (that : any) => void
        onSave: (setting: gdtSettingValue) => Promise<any>
    } : never
  )

  export type gdtKeyValues = {
    [key in gdtSetting]: gdtSettingValue
  } 
  
  export type gdtSetting  = `doctype_${docType}_gdtOutputFolder` | `doctype_${docType}_gdtInputFolder`

  type gdt = "gdtOutputFolder" | 'gdtInputFolder'


  export const parseGDTToJSON = (gdtData: string) : Record<string, any>  => {  
    // Map der Nummern zu den ursprünglichen JSON-Keys
    const mapping: Record<string, string> = {
      "0001": "firstName",
      "0002": "lastName",
      "0003": "username",
      "0004": "email",
      "0005": "matricule",
      "0006": "phone",
      "0007": "birthDate",
      "0008": "address",
      "0009": "mobile",
    };
  
    // Aufteilen des GDT-Datensatzes in Zeilen
    const lines = gdtData.split("\n");
  
    // Das Ergebnis-Objekt
    const result: Record<string, any> = {};
  
    console.devwarn("CAUTION: Adding random numbers to unique values on GDT import for testing purpose!")
    for (const line of lines) {
      const key = line.substring(0, 4).trim(); // Die ersten 4 Zeichen als Key

      var value;
      // for testing purpose, if it is a unique value, we prepend a random number to it.
      if(['username', 'email', "matricule"].includes(mapping[key])){
         value = `${Math.floor(Math.random() * 1000)}${line.substring(5).trim()}`   
      } else if(mapping[key] === "birthDate" /* && /^\d{8}$/.test(value) */){
        // format birthdate with dashes

        let fullValue = line.substring(5).trim();

        value = `${fullValue.substring(0, 4)}-${fullValue.substring(4, 6)}-${fullValue.substring(6, 8)}`;

      } else {
        value = line.substring(5).trim(); // Der Rest als Value
        
      }
  
      // Nur verarbeiten, wenn der Key in der Mapping-Tabelle existiert
      if (mapping[key]) {
        result[mapping[key]] = value;
      }
    }
  
    return result;
  }
  
/*   // Beispiel-GDT-Datensatz
  const gdtInput = `
  0001 formattest
  0002 formattest
  0003 formattest1337
  0004 formattest1337@sharklasers.com
  0005 43543543
  0006 4324324
  0007 20241217
  0008 formattest straße
  0009 4324324
  `.trim();
  
  // GDT-Datensatz in JSON umwandeln
  const jsonData = parseGDTToJSON(gdtInput);
  console.log('jsonData', jsonData); */